var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StateAnalysis',{attrs:{"title":"精神评价报告","report":"jsReportHistories"}})
}
var staticRenderFns = []

export { render, staticRenderFns }